var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-dots"},[_c('div',{attrs:{"id":"status"}},[_c('div',{staticClass:"spinner-chase"},[_c('div',{staticClass:"chase-dot"}),_c('div',{staticClass:"chase-dot"}),_c('div',{staticClass:"chase-dot"}),_c('div',{staticClass:"chase-dot"}),_c('div',{staticClass:"chase-dot"}),_c('div',{staticClass:"chase-dot"})])])])
}]

export { render, staticRenderFns }